import { trackDetail } from "common/analytics"
import { Mobile } from "common/MediaQueries"
import { useEffect } from "react"
import { useTypedSelector } from "store"
import ColorPage from "../color/ColorPage"
import DetailingSidebar from "./DetailingSidebar"

const DetailingPage = () => {
  const { model } = useTypedSelector((state) => state.wizard)

  useEffect(() => {
    if (!model) return

    trackDetail(model.name, model.id)
  }, [model])

  return (
    <>
      <ColorPage hideColorSidebar={true} show360IconOnMobile={true} />

      <Mobile>
        <DetailingSidebar />
      </Mobile>
    </>
  )
}

export default DetailingPage
